import type { Context } from 'react';
import { createContext } from 'react';

import type { CurrentUserContextValue } from '../../../providers/current-user-provider/current-user-context';
import { useCurrentUserContext } from '../../../providers/current-user-provider/current-user-provider';
import { useAppConfigContext } from '../../../providers/is-idm-provider/app-config-provider';
import { useUpsertCurrentUserPreferences } from '../../user/hooks/use-mutation/use-upsert-current-user-preferences';
import type { Discipline } from '../types';

type UseUpsertCurrentUserPreferencesReturn = Pick<
  ReturnType<typeof useUpsertCurrentUserPreferences>,
  'mutateAsync'
>;

type AppConfigContextReturn = {
  appConfig?: {
    featureConfiguration?: {
      disciplines?: Discipline[];
    };
  };
};

export interface UseDisciplinesContextInterface {
  useCurrentUserContext: () => CurrentUserContextValue;
  useAppConfigContext: () => AppConfigContextReturn;
  useUpsertCurrentUserPreferences: () => UseUpsertCurrentUserPreferencesReturn;
}

const getDefaultProperties = (): UseDisciplinesContextInterface => ({
  useCurrentUserContext,
  useAppConfigContext,
  useUpsertCurrentUserPreferences,
});

let useDisciplinesContext: Context<UseDisciplinesContextInterface>;

export const getUseConfiguredDisciplinesContext = () => {
  if (!useDisciplinesContext) {
    useDisciplinesContext = createContext(getDefaultProperties());
  }
  return useDisciplinesContext;
};
